export const toggleColumns = [
  { id: 1, name: "Invoice#" },
  { id: 7, name: "Date" },
  { id: 10, name: "Order By" },
  { id: 9, name: "Description" },
  { id: 10, name: "Created By" },
  { id: 10, name: "Updated By" },
];

export const searchExpensePills = [
  { id: 1, title: "Total Amount", value: "Rs 237,489,193", variant: "dark" },
  { id: 1, title: "Expense Found", value: "3097", variant: "info" },
  { id: 1, title: "Total Quantity", value: "1,962,237,110", variant: "dark" },
];

export const searchExpenseTableColumns = [
  { id: 1, name: "#" },
  { id: 2, name: "Invoicd#" },
  { id: 3, name: "Amount" },
  { id: 4, name: "Date" },
  { id: 5, name: "Expense By" },
  { id: 6, name: "Type" },
  { id: 7, name: "Category" },
  { id: 8, name: "Project" },
  { id: 9, name: "Source" },
];
